"use client"

import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Autocomplete,
  TextField,
  Box,
  Typography,
  IconButton,
  Checkbox,
  FormControlLabel,
  Divider,
} from "@mui/material"
import { Close as CloseIcon, Settings as SettingsIcon } from "@mui/icons-material"

const ModalConfiguracionItem = ({
  open,
  onClose,
  selectedUbicacion,
  setSelectedUbicacion,
  ubicaciones,
  selectedNegocio,
  setSelectedNegocio,
  negocios,
  checkboxFacturaNegro,
  setCheckboxFacturaNegro,
}) => {
  return (
    <Dialog
      open={open}
      onClose={onClose}
      maxWidth="sm"
      fullWidth
      PaperProps={{
        sx: {
          borderRadius: 2,
        },
      }}
    >
      <DialogTitle
        sx={{
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          backgroundColor: "#5b5b5f",
          color: "white",
          py: 1.5,
        }}
      >
        <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
          <SettingsIcon />
          <Typography variant="h6">Configuración</Typography>
        </Box>
        <IconButton onClick={onClose} sx={{ color: "white" }} size="small">
          <CloseIcon />
        </IconButton>
      </DialogTitle>
      <DialogContent sx={{ pt: 3 }}>
        <Box sx={{ display: "flex", flexDirection: "column", gap: 2 }}>
          <Autocomplete
            size="small"
            fullWidth
            disablePortal
            options={ubicaciones.map((it) => ({
              id: it.id,
              label: it.descripcion,
            }))}
            value={selectedUbicacion}
            onChange={(event, newValue) => {
              setSelectedUbicacion(newValue)
            }}
            renderInput={(params) => (
              <TextField {...params} label="Ubicación" size="small" />
            )}
          />
          <Autocomplete
            size="small"
            fullWidth
            disablePortal
            options={negocios.map((it) => ({
              id: it.id,
              label: it.descripcion,
            }))}
            value={selectedNegocio}
            onChange={(event, newValue) => {
              setSelectedNegocio(newValue)
            }}
            renderInput={(params) => (
              <TextField {...params} label="Negocio" size="small" />
            )}
          />
          
          <Divider sx={{ my: 1 }} />
          
          <FormControlLabel
            control={
              <Checkbox
                checked={!checkboxFacturaNegro}
                onChange={(e) => {
                  setCheckboxFacturaNegro(!e.target.checked)
                  if (e.target.checked) {
                    // Resetear descuento si se marca
                  }
                }}
                size="small"
              />
            }
            label={
              <Typography variant="body2" sx={{ fontSize: "0.875rem" }}>
                Facturar (F)
              </Typography>
            }
          />
        </Box>
      </DialogContent>
      <DialogActions sx={{ p: 2 }}>
        <Button onClick={onClose} variant="contained" fullWidth>
          Aceptar
        </Button>
      </DialogActions>
    </Dialog>
  )
}

export default ModalConfiguracionItem

